import React, { createContext, useContext } from 'react';

const AnalyticsContext = createContext(null);
function AnalyticsProvider({ children, instance }) {
    return React.createElement(AnalyticsContext.Provider, { value: instance }, children);
}
function useAnalytics() {
    return useContext(AnalyticsContext);
}

export { AnalyticsProvider, useAnalytics };
